import { statusAuditTrail } from '@/store/params';
import { date } from '../../../../lib/helpers';
import { headers, search } from './attributes';

export default {
  data: () => ({
    options: {},
    headers,
    search,
    filterValue: {
      action_date: [],
      username: '',
      role: '',
      origin_path: '',
      ip_address: '',
      status: '',
    },
    filterType: [
      { key: 'username', type: 'textfield', props: { label: 'Username' } },
      { key: 'role', type: 'select', props: { label: 'Role', items: [] } },
      { key: 'origin_path', type: 'textfield', props: { label: 'Location Menu' } },
      { key: 'ip_address', type: 'textfield', props: { label: 'IP Address' } },
      { key: 'status', type: 'select', props: { label: 'Status', items: statusAuditTrail } },
      { key: 'action_date', type: 'daterange', props: { label: 'Action Date & Time', includeToday: true, limitRangeTo30Days: true, defaultToday: true, withTime: true } },
    ],
  }),
  async mounted() {
    this.getRoles();
  },
  computed: {
    itemsRole() {
      return this.$store.state.rbac.role.allActiveRole;
    },
    allData() {
      return this.$store.state.auditTrailAdmin.allData;
    },
    totalData() {
      return this.$store.state.auditTrailAdmin.totalData;
    },
    totalPage() {
      return this.$store.state.auditTrailAdmin.totalPage;
    },
    loading() {
      return this.$store.state.auditTrailAdmin.loading;
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
    },
  },
  methods: {
    getRoles() {  
      const typeRoute =
        this.$route.name === 'UserAuditTrailMerchant' ? 'merchant' : 'admin';

      this.$store.dispatch('rbac/role/fetchActiveRoles', {
        date,
        source: typeRoute,
      }).then(() => {
        const roleItems = this.itemsRole.map(item => ({
          text: item.role,
          value: item.role
        }));
        
        const roleFilter = this.filterType.find(f => f.key === 'role');
        if (roleFilter) {
          roleFilter.props.items = roleItems;
        }
      });
    },
    baseFilterData(newSearch) {
      this.search.action_date = newSearch.action_date || [];
      this.search.username = newSearch.username || '';
      this.search.role = newSearch.role || '';
      this.search.origin_path = newSearch.origin_path || '';
      this.search.ip_address = newSearch.ip_address || '';
      this.search.status = newSearch.status || '';
      this.options.page = 1;
      this.getData(); 
    },
    updateSearch(newSearch) {
      this.baseFilterData(newSearch);
    },
    showType(newSearch) {
      this.baseFilterData(newSearch);
    },
    getData() {
      const { page, itemsPerPage } = this.options;

      this.$store
        .dispatch('auditTrailAdmin/getData', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        });
    },
    copyToClipboard(content) {
      const text = typeof content === 'object' ? JSON.stringify(content, null, 2) : content;
      navigator.clipboard.writeText(text);
    },
    clearSearch() {
      this.search.action_date = [];
      this.search.username = '';
      this.search.role = '';
      this.search.origin_path = '';
      this.search.ip_address = '';
      this.search.status = '';
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};